import { RequiredTranslationsTemplate } from '.'

const fr: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Français',
  },
  home: {
    title: 'RAPPEL PRODUIT ROCKRIDER XC 500 S',
    description:
      'Vous avez acheté un VTT ROCKRIDER XC 500 S et nous vous en remercions. Nous avons identifié une fragilité potentielle au niveau de la fourche. Seuls certains numéros de série sont concernés, nous vous invitons à saisir les 6 derniers chiffres de votre n° de série afin de savoir si votre vélo est concerné par cette campagne de rappel:',
    form: {
      title: 'Merci de saisir les infos suivantes :',
      fields: {
        serialNumber: 'N° série',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'Email',
        phone: 'Tél.',
        country: 'Pays',
        submit: 'Valider',
        choose: 'Choisir...',
      },
      errors: {
        requiredField: 'Ce champ est requis',
        unknownSerialNumber: 'Numéro de Série inconnu',
        provide6Numbers: 'Attention, 6 chiffres sont nécessaires',
      },
      confirmations: {
        good: {
          title: "Votre vélo n'est pas concerné",
          p1: 'Nous vous informons que votre vélo n’est pas concerné par ce rappel, vous pouvez donc continuer de profiter de celui-ci en toute sécurité.',
          p2: 'Nous nous excusons pour la gêne occasionnée,',
          p3: 'Sportivement votre,',
          p4: 'Les équipes Décathlon',
        },
        defective: {
          title: 'Votre vélo est concerné',
          p1: 'Nous vous demandons de ne plus l’utiliser et de vous rapprocher de l’atelier de votre magasin le plus proche afin de procéder au remplacement de la fourche.',
          p2: 'Nous attirons votre attention sur le fait que le produit pourrait être immobilisé plusieurs jours. Sachez que tout sera fait pour réduire ces délais afin de vous satisfaire. Nous vous conseillons de consulter directement l’atelier de votre magasin habituel pour avoir une estimation du délai de réparation.',
          p3: 'Trouvez un atelier décathlon à proximité de chez vous :',
          decathlonLocatorLink: 'https://www.decathlon.fr/store-locator',
          p4: 'Vous trouverez ci-dessous votre bon d’intervention à présenter à notre technicien lors de votre venue en atelier :',
          p5: 'Pour plus d’informations, nous vous invitons à contacter notre centre de relation dédié pour ce rappel au 0 805 38 38 49, numéro gratuit depuis la France métropolitaine (ouvert du lundi au vendredi de 9h à 19h) ou par mail à l’adresse rappel.decathlon@fandi.fr',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Où trouver mon n° de série ?',
      description: 'Le numéro de série se trouve au niveau du cadre',
    },
  },
}

export default fr
